import React, { useContext } from "react";
import { AppContext } from "../../App";
import Can from "../can/Can";
import { blockchainUrl } from "../../rbac-consts";
import AdminBlockchainUrlContainer from "./admin/BlockchainUrlContainer";

const BlockchainUrlWrapper = ({ match }) => {

  const { user } = useContext(AppContext);

  return (
    <>
      <Can
        role={user.roles}
        perform={blockchainUrl.ADMIN}
        yes={() => (
          <AdminBlockchainUrlContainer match={match} />
        )}
      />
    </>
  );
};

export default BlockchainUrlWrapper;